import { useEffect, useRef } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { fetchKnowledgeBaseSectors } from '../api/knowledgebase/api';
import { kbSectorsState } from '../store/common-atoms';

export const useFetchSectors = (autoFetch = true) => {
  const [{ sectors, sectorsById, sectorsByName, idToName, nameToId, isLoading }, setState] = useAtom(kbSectorsState);
  const resetState = useResetAtom(kbSectorsState);
  const loadingRef = useRef(false);

  const fetchSectors = async () => {
    if (loadingRef.current || sectors?.length) return;

    loadingRef.current = true;
    setState(prev => ({ ...prev, isLoading: true }));
    try {
      const list = await fetchKnowledgeBaseSectors();

      setState(prev => ({
        ...prev,
        sectors: list,
        sectorsById: list.reduce((acc, s) => ({ ...acc, [s.id]: s }), {}),
        sectorsByName: list.reduce((acc, s) => ({ ...acc, [s.name]: s }), {}),
        idToName: list.reduce((acc, s) => ({ ...acc, [s.id]: s.name }), {}),
        nameToId: list.reduce((acc, s) => ({ ...acc, [s.name]: s.id }), {}),
        isLoading: false
      }));
    } catch (e) {
      resetState();
    }
    loadingRef.current = false;
  };

  useEffect(() => {
    autoFetch && fetchSectors();
  }, [sectors]);

  return { sectors, sectorsById, sectorsByName, idToName, nameToId, isLoading, fetchSectors };
};

export const useSectorsState = () => {
  const { sectors, sectorsById, sectorsByName, idToName, nameToId, isLoading } = useAtomValue(kbSectorsState);
  // TODO maybe add options with icons - need to decide if the add 'all_sectors' as first and deal with it as known id
  return { sectors, sectorsById, sectorsByName, idToName, nameToId, isLoading };
};
